import { CoolLocalStorage } from '@angular-cool/storage';
import { Injectable, NgZone } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ModalConfig } from 'shared/components/modal-dialog/modal-config.model';
import { ModalDialogComponent } from 'shared/components/modal-dialog/modal-dialog.component';

@Injectable()
export class ModalService {
  private modalInstance: MatDialogRef<ModalDialogComponent>;
  private readonly doNotShowAgainStorageKey = 'modal-do-not-show-again';
  private doNotShowAgainList = new Set();

  constructor(private dialog: MatDialog, private _zone: NgZone, private localStorage: CoolLocalStorage) {
    const savedDoNotShowList = this.localStorage.getItem(this.doNotShowAgainStorageKey);
    if (savedDoNotShowList) {
      this.doNotShowAgainList = new Set(JSON.parse(savedDoNotShowList));
    }
  }

  show(modalOptions: ModalConfig) {
    if (modalOptions.doNotShowAgainById && this.doNotShowAgainList.has(modalOptions.doNotShowAgainById)) {
      return;
    }
    this._zone.run(() => {
      this.modalInstance = this.dialog.open(ModalDialogComponent, {
        width: '400px',
        panelClass: 'app-modal-dialog',
        disableClose: true,
        data: modalOptions
      });
      this.modalInstance.afterClosed().subscribe(result => {
        if (result === true) {
          modalOptions?.confirmButton?.clickEvent?.();
        }
        if (result !== true) {
          modalOptions?.cancelButton?.clickEvent?.();
        }

        modalOptions?.resultFunction?.();
      });
    });
  }

  close(resultParam?) {
    if (this.modalInstance) {
      this.modalInstance.close(resultParam);
    }
  }

  updateDoNotShowAgainState(id: string, newState: boolean) {
    if (newState) {
      this.doNotShowAgainList.add(id);
    } else {
      if(this.doNotShowAgainList.has(id)) {
        this.doNotShowAgainList.delete(id);
      }
    }
    this.localStorage.setItem(this.doNotShowAgainStorageKey, JSON.stringify(Array.from(this.doNotShowAgainList)));
  }
}
